import React, { Component } from "react";
import { Col, message, Progress, Row, Select, Tag, Tooltip } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import axios from "axios";
import moment from "moment";
import "moment/locale/es";
import { connect } from "react-redux";
import { ButtonItem, DatePickerItem, SegmentedItem, SelectItem, TableItem, TreeSelectItem } from "../../../Components/Items";
import { TreeSelect } from "antd5";

moment.locale("es");

const DIAS_BITACORA = 90;

class BitacoraIa extends Component {
  state = {
    loading: false,
    registros: [],
    limite: 0,
    empresas: [],
    usuarios: [],
    modulosFunciones: [],
    funciones: [],
    empresaId: undefined,
    usuarioId: undefined,
    estado: "todas",
    diasAtras: 0,
    consumo: [],
  };

  componentDidMount() {
    this.consultarFiltros();
    this.consultarBitacora();
    this.consultarConsumo();
  }

  componentDidUpdate(prevProps) {
    if (this.props.activo && !prevProps.activo) {
      this.consultarBitacora();
      this.consultarConsumo();
    }
  }

  consultarConsumo = async () => {
    try {
      const res = await axios.post("ia/selectConsumoIa", {}, { headers: this.props.headersToken });
      this.setState({ consumo: res.data.success === 2 ? res.data.data : [] });
    } catch (error) {
      this.setState({ consumo: [] });
    }
  };

  renderLimite = (titulo, usadas, limite, sinLimite) => {
    const formato = (valor) => Number(valor || 0).toLocaleString("es-MX");
    if (sinLimite) {
      return (
        <div style={{ fontSize: 12 }}>
          <span style={{ color: "#888" }}>{titulo}: </span>
          <span style={{ fontWeight: 600 }}>{formato(usadas)}</span>
          <span style={{ color: "#888" }}> consultas (sin límite)</span>
        </div>
      );
    }
    const porcentaje = limite ? Math.min(100, Math.round((usadas / limite) * 100)) : 100;
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "space-between", fontSize: 12 }}>
          <span style={{ color: "#888" }}>{titulo}</span>
          <span style={{ fontWeight: 600 }}>{formato(usadas)} / {formato(limite)}</span>
        </div>
        <Progress
          percent={porcentaje}
          size="small"
          showInfo={false}
          strokeColor={porcentaje >= 100 ? "#ff4d4f" : porcentaje >= 80 ? "#faad14" : "#00BFD6"}
        />
      </div>
    );
  };

  renderConsumo = () => {
    const consumo = this.state.empresaId
      ? this.state.consumo.filter((empresa) => empresa.empresaId === this.state.empresaId)
      : this.state.consumo;
    if (consumo.length === 0) return null;
    return (
      <Row gutter={[12, 12]} style={{ marginBottom: 12 }}>
        {consumo.map((empresa) => (
          <Col xs={24} md={12} xl={8} key={empresa.empresaId}>
            <div
              style={{
                padding: "10px 14px",
                borderRadius: 8,
                background: "#fff",
                border: "1px solid rgb(235, 237, 240)",
                boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                display: "flex",
                flexDirection: "column",
                gap: 6,
              }}
            >
              <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 8 }}>
                <span style={{ fontWeight: 600 }}>{empresa.empresa}</span>
                {empresa.paquete ? (
                  <Tooltip title={empresa.paquete.descripcion || null}>
                    <Tag color="purple" style={{ marginRight: 0 }}>{empresa.paquete.nombre}</Tag>
                  </Tooltip>
                ) : (
                  <Tag color="red" style={{ marginRight: 0 }}>Sin paquete</Tag>
                )}
              </div>
              {empresa.paquete ? (
                <>
                  {this.renderLimite("Hoy", empresa.usadasHoy, empresa.paquete.consultasDiarias, empresa.paquete.sinLimite)}
                  {this.renderLimite("Este mes", empresa.usadasMes, empresa.paquete.consultasMensuales, empresa.paquete.sinLimite)}
                </>
              ) : (
                <span style={{ fontSize: 12, color: "#888" }}>La IA no puede consultar hasta que BIWO asigne un paquete a esta empresa.</span>
              )}
            </div>
          </Col>
        ))}
      </Row>
    );
  };

  consultarFiltros = async () => {
    try {
      const [empresas, usuarios, funciones] = await Promise.all([
        axios.post("ia/selectEmpresasIa", {}, { headers: this.props.headersToken }),
        axios.post("ia/selectUsuariosIa", {}, { headers: this.props.headersToken }),
        axios.post("ia/selectFuncionesBitacoraIa", {}, { headers: this.props.headersToken }),
      ]);
      this.setState({
        empresas: empresas.data.success === 2 ? empresas.data.data : [],
        usuarios: usuarios.data.success === 2 ? usuarios.data.data : [],
        modulosFunciones: funciones.data.success === 2 ? funciones.data.data : [],
      });
    } catch (error) {
      this.setState({ empresas: [], usuarios: [], modulosFunciones: [] });
    }
  };

  consultarBitacora = async () => {
    const dia = moment().subtract(this.state.diasAtras, "days");
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "ia/selectBitacoraIa",
        {
          empresaId: this.state.empresaId,
          usuarioId: this.state.usuarioId,
          funciones: this.state.funciones,
          estado: this.state.estado,
          fechaInicial: dia.clone().startOf("day").toDate(),
          fechaFinal: dia.clone().endOf("day").toDate(),
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        this.setState({ registros: res.data.data, limite: res.data.limite });
      } else {
        message.error(res.data.message || "No se pudo consultar la bitácora");
      }
    } catch (error) {
      message.error("No se pudo consultar la bitácora");
    }
    this.setState({ loading: false });
  };

  render() {
    const columns = [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        width: 170,
        render: (value) => moment(value).format("DD/MM/YYYY HH:mm:ss"),
      },
      { title: "Usuario", dataIndex: "usuario", key: "usuario" },
      { title: "Empresa", dataIndex: "empresa", key: "empresa", responsive: ["md"] },
      {
        title: "Función",
        dataIndex: "funcion",
        key: "funcion",
        render: (value, record) => (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span>{value}</span>
            <span style={{ fontSize: 12, color: "#888" }}>{record.modulo}</span>
          </div>
        ),
      },
      { title: "Asistente", dataIndex: "asistente", key: "asistente", responsive: ["md"] },
      { title: "IP", dataIndex: "ip", key: "ip", responsive: ["lg"] },
      {
        title: "Resultados",
        dataIndex: "resultados",
        key: "resultados",
        align: "center",
        width: 100,
        render: (value) => (value ?? ""),
      },
      {
        title: "Estado",
        dataIndex: "exito",
        key: "exito",
        width: 110,
        render: (value, record) =>
          value ? (
            <Tag color="green">Correcta</Tag>
          ) : (
            <Tooltip title={record.error}>
              <Tag color="red">Error</Tag>
            </Tooltip>
          ),
      },
      {
        title: "Duración",
        dataIndex: "duracionMs",
        key: "duracionMs",
        align: "right",
        width: 100,
        responsive: ["md"],
        render: (value) => (value != null ? `${(value / 1000).toFixed(2)} s` : ""),
      },
    ];

    const totalErrores = this.state.registros.filter((registro) => !registro.exito).length;
    const indicadores = [
      { titulo: "Consultas", valor: this.state.registros.length, color: "#00BFD6" },
      { titulo: "Correctas", valor: this.state.registros.length - totalErrores, color: "#52c41a" },
      { titulo: "Con error", valor: totalErrores, color: "#ff4d4f" },
      { titulo: "Usuarios", valor: new Set(this.state.registros.map((registro) => registro.usuario)).size, color: "#800080" },
    ];

    return (
      <>
        {this.renderConsumo()}
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", flexWrap: "wrap", gap: 12, marginBottom: 12 }}>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap", alignItems: "center" }}>
            <SegmentedItem
              options={[
                { label: "Hoy", value: 0 },
                { label: "Ayer", value: 1 },
                { label: "Antier", value: 2 },
              ]}
              value={this.state.diasAtras}
              onChange={(diasAtras) => this.setState({ diasAtras }, this.consultarBitacora)}
            />
            <DatePickerItem
              allowClear={false}
              style={{ width: 140 }}
              value={moment().subtract(this.state.diasAtras, "days")}
              disabledDate={(fecha) => fecha && (fecha > moment().endOf("day") || fecha < moment().subtract(DIAS_BITACORA, "days").startOf("day"))}
              onChange={(fecha) => {
                if (!fecha) return;
                const diasAtras = moment().startOf("day").diff(fecha.clone().startOf("day"), "days");
                this.setState({ diasAtras }, this.consultarBitacora);
              }}
            />
            <SegmentedItem
              options={[
                { label: "Todas", value: "todas" },
                { label: "Correctas", value: "correctas" },
                { label: "Con error", value: "errores" },
              ]}
              value={this.state.estado}
              onChange={(estado) => this.setState({ estado }, this.consultarBitacora)}
            />
          </div>
          <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
            {indicadores.map((indicador) => (
              <div
                key={indicador.titulo}
                style={{
                  minWidth: 100,
                  padding: "6px 14px",
                  borderRadius: 8,
                  background: "#fff",
                  border: "1px solid rgb(235, 237, 240)",
                  borderLeft: `4px solid ${indicador.color}`,
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                }}
              >
                <div style={{ fontSize: 12, color: "#888" }}>{indicador.titulo}</div>
                <div style={{ fontSize: 18, fontWeight: 600, color: indicador.color }}>{indicador.valor}</div>
              </div>
            ))}
          </div>
        </div>
        <Row
          gutter={[12, 12]}
          align="middle"
          style={{
            margin: "0 0 12px 0",
            padding: "12px 6px",
            borderRadius: 8,
            background: "rgba(0, 191, 214, 0.06)",
            border: "1px solid rgba(0, 191, 214, 0.25)",
          }}
        >
          <Col xs={24} md={7}>
            <SelectItem
              allowClear
              placeholder="Todas las empresas"
              value={this.state.empresaId}
              onChange={(empresaId) => this.setState({ empresaId })}
              style={{ width: "100%" }}
            >
              {this.state.empresas.map((empresa) => (
                <Select.Option key={empresa._id} value={empresa._id}>
                  {empresa.nombre}
                </Select.Option>
              ))}
            </SelectItem>
          </Col>
          <Col xs={24} md={7}>
            <SelectItem
              allowClear
              placeholder="Todos los usuarios"
              value={this.state.usuarioId}
              onChange={(usuarioId) => this.setState({ usuarioId })}
              style={{ width: "100%" }}
            >
              {this.state.usuarios.map((usuario) => (
                <Select.Option key={usuario._id} value={usuario._id}>
                  {usuario.nombreCompleto}
                </Select.Option>
              ))}
            </SelectItem>
          </Col>
          <Col xs={24} md={7}>
            <TreeSelectItem
              noBuscar
              allowClear
              treeCheckable
              treeDefaultExpandAll
              showSearch
              treeNodeFilterProp="title"
              maxTagCount="responsive"
              showCheckedStrategy={TreeSelect.SHOW_CHILD}
              placeholder="Todas las funciones"
              value={this.state.funciones}
              onChange={(funciones) => this.setState({ funciones })}
              treeData={this.state.modulosFunciones.map((modulo) => ({
                title: modulo.modulo,
                value: "modulo:" + modulo.modulo,
                key: "modulo:" + modulo.modulo,
                children: modulo.funciones.map((funcion) => ({ title: funcion.nombre, value: funcion.clave, key: funcion.clave })),
              }))}
              style={{ width: "100%" }}
            />
          </Col>
          <Col xs={24} md={3}>
            <Tooltip title="Consultar" placement="top" overlayInnerStyle={{ fontSize: '10px', padding: '1px 5px', minHeight: 'auto' }}>
              <ButtonItem
                type="default"
                cyan
                icon={<SearchOutlined />}
                onClick={() => {
                  this.consultarBitacora();
                  this.consultarConsumo();
                }}
                style={{ width: "100%" }}
              />
            </Tooltip>
          </Col>
        </Row>
        {this.state.limite > 0 && this.state.registros.length >= this.state.limite && (
          <p style={{ color: "#888" }}>Se muestran los {this.state.limite} registros más recientes del día. Usa los filtros para ver otros.</p>
        )}
        <TableItem size="small" rowKey="_id" dataSource={this.state.registros} columns={columns} loading={this.state.loading} />
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(BitacoraIa);
